import React, { forwardRef, useEffect, useImperativeHandle } from 'react';
import { CnResult } from '@cainiaofe/cn-ui';
import { CnChart as ICnChart } from '@/components/cn-chart';
import {
  calculateAdvancedConfig,
  calculateFeature,
  getChartCommonStyle,
  isDesignMode,
} from '@/lowcode/common/util/util';
import useFilterSearchListener from '../common/hooks/useFilterSearchListener';
import { FeaturePosition } from '@/types/feature-position';
import { useData } from '@/lowcode/common/hooks/useData';
import WrapperContainer from '../common/wrapper-container';
import { BaseLowCodeProps, themeMap, defaultTheme } from '@/lowcode/common/types';
import { EmptyData } from '../common/empty-data';

const CnChart = forwardRef((props: BaseLowCodeProps, ref) => {
  const { filterConfig, chartStyle, forceRequest, _context } = props || {};
  const { _bindFilter } = filterConfig || {};
  const isDesign = isDesignMode(props);

  const {
    data: listData,
    error,
    loading,
    refreshData: sendRequest,
  } = useData({
    config: { ...props, isDesign },
    source: 'chart',
  });

  useFilterSearchListener({
    _bindFilter,
    sendRequest,
    _context,
  });

  useImperativeHandle(ref, () => ({
    load: sendRequest,
  }));

  useEffect(() => {
    if (forceRequest) {
      sendRequest();
    }
  }, [forceRequest]);

  if (!listData) {
    return (
      <EmptyData
        height={chartStyle?.height}
        emptyImg={
          'https://gw.alicdn.com/imgextra/i1/O1CN01iq0YnU1urGwPwcW7t_!!6000000006090-2-tps-395-262.png'
        }
      />
    );
  }

  const renderMain = () => {
    if (!listData?.length) {
      return <CnResult type="empty" title="数据为空" subTitle="暂无数据" />;
    }

    const realOptions = {
      color: themeMap[chartStyle?.themeColor || defaultTheme].color,
      data: listData,
    };

    const finalOptions = calculateAdvancedConfig({
      props,
      options: calculateFeature({
        props,
        options: realOptions,
        position: FeaturePosition.column,
      }),
      state: _context?.state,
    });

    if (
      isDesign &&
      Object.keys(finalOptions).length === 1 &&
      Object.keys(finalOptions)[0] === 'data'
    ) {
      return (
        <CnResult
          style={{ height: chartStyle?.height }}
          type="empty"
          icon="https://img.alicdn.com/imgextra/i1/O1CN01iq0YnU1urGwPwcW7t_!!6000000006090-2-tps-395-262.png"
          title="暂无数据"
          subTitle="自定义图表请前往预览态查看效果"
        />
      );
    }

    return <ICnChart {...getChartCommonStyle(props)} {...finalOptions} />;
  };

  return (
    <WrapperContainer loading={loading} error={error}>
      {renderMain()}
    </WrapperContainer>
  );
});

CnChart.displayName = 'CnChartPro';
export default CnChart;

export { CnChart };
